import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import {Header, Icon, Message, Table} from 'semantic-ui-react';
import styled from 'styled-components';
import {compose, isNil, prop, sortBy, toLower} from 'ramda';
import {retrieveStudents} from '../../api';
import MenuButton from '../../components/Button/MenuButton';
import {CharcoalContainer} from '../../components/Container/ContainerMix';
import {getSchoolProperty, userHasRole} from '../../util/Session';

const FullHeightCharcoalContainer = styled(CharcoalContainer)`
  height: calc(100vh);
  overflow-y: auto;
`;

const StyledMessage = styled(Message)`
  min-height: inherit !important;
  @media only screen and (max-width: 767px) {
    min-height: 175px !important;
  }
`;

class StudentPoints extends Component {
  constructor(props) {
    super(props);

    this.state = {
      column: 'first_name',
      direction: 'ascending',
      isLoading: false,
      students: []
    };
  }

  componentDidMount() {
    const {router} = this.props;

    // Gracefully handle if logged in user is not a teacher client-side.
    const isTeacher = userHasRole('staff');
    if (!isTeacher) {
      router.push('/dashboard');
      return;
    }

    const schoolId = getSchoolProperty('id');
    this.setState({isLoading: true});
    return retrieveStudents(schoolId)
      .then(response => {
        this.setState({students: response.data.users});
        this.setState({isLoading: false});
      });
  }

  handleSort = (clickedColumn) => () => {
    const {column, students, direction} = this.state;

    if (column !== clickedColumn) {
      let sorter = sortBy(prop(clickedColumn));
      if (clickedColumn === 'first_name') {
        sorter = sortBy(compose(toLower, prop(clickedColumn)));
      }

      this.setState({
        column: clickedColumn,
        students: sorter(students),
        direction: 'ascending'
      });

      return;
    }

    this.setState({
      students: students.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending'
    });
  };

  render() {
    const {column, direction, isLoading, students} = this.state;
    const {onClickSidebar} = this.props;

    return (
      <FullHeightCharcoalContainer>
        <MenuButton onClick={onClickSidebar}/>
        <Header as="h2" icon textAlign="center">
          <Icon name="chart bar" circular/>
          <Header.Content>Active Students {!isNil(students) && `(${students.length})`} </Header.Content>
        </Header>
        <StyledMessage
          icon="info circle"
          header="Who are 'active' students?"
          content="The number of active students is the number of students who have logged an activity in the current active interval.  The active interval is setup by a school admin."
        />
        {
          isLoading ?
            <i aria-hidden="true" className="spinner loading icon"/> :
            (
              <Table unstackable sortable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell
                      sorted={column === 'first_name' ? direction : null}
                      onClick={this.handleSort('first_name')}
                    >
                      Name
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      sorted={column === 'points' ? direction : null}
                      onClick={this.handleSort('points')}
                    >
                      Points
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      sorted={column === 'last_activity_logged_at' ? direction : null}
                      onClick={this.handleSort('last_activity_logged_at')}
                    >
                      Last activity
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                {students.map(student => (
                  <Table.Body key={student.id}>
                    <Table.Row>
                      <Table.Cell>{student.first_name} {student.last_name}</Table.Cell>
                      <Table.Cell>{student.points}</Table.Cell>
                      <Table.Cell>{student.last_activity_logged_at}</Table.Cell>
                    </Table.Row>
                  </Table.Body>
                ))}
              </Table>
            )
        }

      </FullHeightCharcoalContainer>
    );
  }
}

StudentPoints.propTypes = {
  onClickSidebar: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired
};

export default withRouter(StudentPoints);



// WEBPACK FOOTER //
// ./src/pages/Schools/StudentPoints.js